import { SelectOption } from "@veneer/core";

const useSearchSelect = () => {
  async function handleSearch(
    value: string,
    optionsCopy: SelectOption[],
    setOptions: (options: React.SetStateAction<SelectOption[]>) => void
  ) {
    try {
      const lowerCaseQuery = value.toLocaleLowerCase();

      const filteredOptions = optionsCopy.filter((objeto) =>
        objeto.label?.toLocaleLowerCase().includes(lowerCaseQuery)
      );

      setOptions(filteredOptions);
    } catch (error) {
      console.error("Error during search: ", error);
    }
  }

  return {
    handleSearch,
  };
};

export default useSearchSelect;
